import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";

import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import { Circle } from "@react-google-maps/api";

import useCustom from "../customHook/customHook";
const constants = require("file-configs/constants");

export default function CreateMap(props) {
  const [globalState, setGlobalState] = useCustom();
  const [map, setMap] = useState(null);
  const [searchResult, setSearchResult] = useState("");
  const [center, setCenter] = useState([]);

  const [markers, setMarkers] = useState([]);
  const mapRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: constants.GOOGLE_MAP_KEY,
  });

  const containerStyle = { height: "300px" };
  const destinationRef = useRef();

  useEffect(() => {
    if (
      Object.keys(globalState.current_coors).length !== 0 &&
      isLoaded == true
    ) {
      setCenter([globalState.current_coors]);
      setMarkers([globalState.current_coors]);
      markers.push(globalState.current_coors);
    }
  }, [globalState.current_coors, isLoaded]);

  const handleMarkerMove = (event) => {
    setMarkers([{ lat: event.latLng.lat(), lng: event.latLng.lng() }]);
    setGlobalState({
      current_coors: { lng: event.latLng.lng(), lat: event.latLng.lat() },
    });
    map.panTo({ lat: event.latLng.lat(), lng: event.latLng.lng() });
  };

  const handleCenter = () => {
    if (!mapRef.current) return;

    const newPos = mapRef.current.getCenter().toJSON();
    setCenter(newPos);
  };

  const onLoad = React.useCallback(function callback(map) {
    map.setCenter({
      lat: globalState.current_coors.lat,
      lng: globalState.current_coors.lng,
    });
    setMap(map);
  }, []);

  function onLoad2(autocomplete) {
    setSearchResult(autocomplete);
  }

  function onPlaceChanged() {
    if (searchResult != null) {
      //variable to store the result
      const place = searchResult.getPlace();

      // setGlobalState({ address_from_google: place.formatted_address });

      setMarkers([
        {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      ]);
      setGlobalState({
        current_coors: {
          lng: place.geometry.location.lng(),
          lat: place.geometry.location.lat(),
        },
      });
      map.panTo({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    }
  }

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  return isLoaded == true && Object.keys(markers).length !== 0 ? (
    <>
      <div>
        <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad2}>
          <input
            type="text"
            class="form-control mb-3"
            id="searchAddressTextBox"
            ref={destinationRef}
            placeholder="พิมพ์เพื่อค้นหาสถานที่"
          />
        </Autocomplete>
      </div>
      <GoogleMap
        onClick={handleMarkerMove}
        mapContainerStyle={containerStyle}
        onDragEnd={handleCenter}
        zoom={15}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={{
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      >
        {markers.map((marker, index) => (
          <Marker position={marker}></Marker>
        ))}

        {/* <Circle
        onClick={handleMarkerMove} 
        center={markers[0]}
        radius={globalState.org_raduis}
      /> */}
        <></>
      </GoogleMap>
    </>
  ) : (
    <></>
  );
}
